import { CreditAccountPaymentTypeId, getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { QueryOptions } from '../../../services/dynamo'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { toList } from '../../../utils/listUtils'
import { useLoaders, ListResponse } from '../../common'
import { useSystemStateHooks } from '../../system'
import { SaleOrder } from '../state/types'

export const useSaleLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findSale = (id?: string) => find(TableName.SALE_ORDERS, id) as O<SaleOrder>

        const loadAllSales = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter(true) : undefined
            const response = await loadMultiple(TableName.SALE_ORDERS, options)
            return response.dataTypes as SaleOrder[]
        }

        const loadSalesBatch = async (options?: QueryOptions) => {
            const { loadMultiple } = loaders(companyId)
            return loadMultiple(TableName.SALE_ORDERS, options) as Promise<ListResponse<SaleOrder>>
        }

        // TODO analizar los de abajo de esta linea 1 por 1 si se puede reemplazar por loadSalesBatch

        const loadSale = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.SALE_ORDERS, id, dbRequest) as Promise<O<SaleOrder>>
        }

        const loadSales = (
            ids: string[],
            dbRequest = false
        ) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.SALE_ORDERS, ids, dbRequest) as Promise<SaleOrder[]>
        }
        
        const loadCreditAccountSales = async () => {
            const { loadMultiple } = loaders(companyId)
            const options = {
                valueFilters: [
                    { prop: 'paymentTypeId', value: CreditAccountPaymentTypeId },
                    { prop: 'cancelled', value: true, equals: false }
                ]
            }
            const response = await loadMultiple(TableName.SALE_ORDERS, options)
            return response.dataTypes as SaleOrder[]
        }

        const loadCustomersSales = (
            customerIds: string[],
            dbRequest = false
        ) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.SALE_ORDERS, dbRequest, 'customerId', customerIds) as Promise<SaleOrder[]>
        }

        const loadSalesWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.SALE_ORDERS, dbRequest, undefined, undefined, toList(propName)) as Promise<SaleOrder[]>
        }

        const countSales = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.SALE_ORDERS, options)
        }

        return {
            findSale,
            loadSalesBatch,
            loadAllSales,
            loadSale,
            loadSales,
            loadCreditAccountSales,
            loadCustomersSales,
            loadSalesWithProp,
            countSales
        }
    }
}
